import React from 'react'
import {Body} from "../../components/Body";
import {graphql, useStaticQuery} from "gatsby";
import {Section} from "../../components/content";
import {Typography} from "../../styles/typography";
import {ResponsiveTypography} from "../../styles/typography.responsive";
import {Spacing} from "../../styles/spacing";
import {Card, CardsContainer, TariffCard} from "../../components/cards";
import {ListSpacer} from "../../components/spacer";
import {Colors, contractAzul, eerieBlack} from "../../styles/colors";
import {ArrowRightIcon} from "../../components/Icon";
import Seo from "../../components/Seo";
import {SiteLink} from "../../components/SiteLink";
import {PLACET_FORM} from "../../links";
import {Button} from "../../components/button";
import {SiteCTA} from "../../components/SiteCTA";

const formatMoney = (price) => {
  return parseFloat(price).toFixed(3).replace('.', ',')
}

const TariffePlacetPage = () => {
  const {placetBusiness, web, core} = useStaticQuery(graphql`
    query {
        placetBusiness{
          pun_extra
          f0_price
          f1_price
          f2_price
          placet_buffer
        }
        web{
          documents_folder
        }
        core {
          network_losses
        }
    }
  `)

  return (
    <Body safe={false}>
      <Seo title={'Tariffe PLACET Business'}/>

      <Section>
        <h1 css={[ResponsiveTypography.heading.h3_700, Spacing.Margin.bottom_24]}>Cosa sono le tariffe PLACET</h1>
        <p css={[Typography.paragraph.p1_400]}>
          Le tariffe PLACET (Prezzo Libero A Condizioni Equiparate di
          Tutela) sono tariffe con una struttura di prezzo e condizioni
          contrattuali definite dall'ARERA (Autorità di Regolazione per
          Energia, Reti e Ambiente), cioè l’ente che regola i mercati
          dell’energia elettrica e del gas
        </p>
      </Section>

      <Section noSpacing={true} css={[Spacing.Margin.bottom_24]}>
        <h2 css={[ResponsiveTypography.heading.h5_500, Spacing.Margin.bottom_24]}>Perché offriamo anche le tariffe
          PLACET?</h2>
        <p css={[Typography.paragraph.p1_400]}>
          Perché come ogni fornitore del mercato libero siamo tenuti ad offrirne almeno
          due, una a prezzo fisso e una a prezzo variabile. Le PLACET sono
          state ideate dall’ARERA per introdurre più trasparenza nel
          mercato libero e rendere più semplici le tariffe luce e gas
        </p>
      </Section>

      <Section noSpacing={true} css={[Spacing.Margin.bottom_80]}>
        <h2 css={[ResponsiveTypography.heading.h5_500, Spacing.Margin.bottom_24]}>Perché dovrei scegliere una tariffa
          PLACET rispetto ad un’altra
          tariffa di Tate?</h2>
        <p css={[Typography.paragraph.p1_400]}>
          Le nostre tariffe sono trasparenti e diamo già
          modo ai nostri clienti di scegliere tra un prezzo fisso e uno
          variabile. In altre parole, non cambia molto con le tariffe
          PLACET, se non la possibilità di richiedere le bollette
          cartacee, cosa che con la nostra app non avrai mai bisogno di
          fare
        </p>
      </Section>

      {/**/}
      {/*Tariffe Luce*/}
      {/**/}
      <Section noSpacing={true} backgroundColor={contractAzul["500"]}
               css={[Spacing.Padding.bottom_40, Spacing.Padding.top_56]}>
        <h2 css={[Typography.heading.h4_700, Colors.Color.eerieBlack0]}>Tariffe PLACET luce</h2>
      </Section>
      <CardsContainer noSpacing={true} backgroundColor={contractAzul["500"]} css={[Spacing.Padding.bottom_56]}>
        <TariffCard
          contractType={'energy'}
          type={'placet luce'}
          title="Prezzo Variabile"
          tariffs={{}}
          description={
            <>
              Prezzo della componente energia elettrica indicizzato sulla base del PUN:
              PUN*{formatMoney(core.network_losses)} + {formatMoney(placetBusiness.pun_extra)}
              €/kWh + {placetBusiness.placet_buffer} €/mese
              <br/>
              <br/>
              <br/>
              <SiteCTA to={PLACET_FORM} name={'Richiedi ora'} section={'placet-luce'}>
                <Button variant={'secondary'}>
                  <span css={[Typography.heading.h6_600]}>Richiedi ora</span>
                </Button>
              </SiteCTA>
            </>
          }
        />
        <ListSpacer horizontalSize={36} verticalSize={40}/>
        <TariffCard
          contractType={'energy'}
          type={'placet luce'}
          title="Prezzo Fisso"
          tariffs={{}}
          description={
            <>
              Prezzo fisso inclusivo di perdite di rete per 12 mesi + {placetBusiness.placet_buffer} €/mese
              <br/>Prezzo monorario: F0: {formatMoney(placetBusiness.f0_price)} €/kWh
              <br/>Prezzo biorario: F1: {formatMoney(placetBusiness.f1_price)} €/kWh
              F23: {formatMoney(placetBusiness.f2_price)} €/kWh
              <br/>
              <br/>
              <SiteCTA to={PLACET_FORM} name={'Richiedi ora'} section={'placet-luce'}>
                <Button variant={'secondary'}>
                  <span css={[Typography.heading.h6_600]}>Richiedi ora</span>
                </Button>
              </SiteCTA>
            </>
          }
        />
      </CardsContainer>
      <CardsContainer backgroundColor={eerieBlack["100"]}>
        <Card>
          <div className="col-12 col-sm-10 offset-sm-2">
            <h4 css={[Typography.heading.h6_700]}>Documentazione contrattuale <br/> tariffa a Prezzo Variabile</h4>
            <SiteLink
              target={'_blank'}
              rel={'noopener noreferrer nofollow'}
              className="weight-500"
              to={`https://my.tate.it/documents/${web.documents_folder}/PLACET_BUSINESS_LUCE_VAR/condizioni_generali_fornitura.pdf`}
              name={'Condizioni generali di fornitura'}
            >
              <p css={[Typography.label.label1_500, Spacing.Margin.vertical_24, Spacing.Flex.vertical_center]}>
                <ArrowRightIcon color={eerieBlack['800']} css={[Spacing.Padding.right_8]}/>
                Condizioni generali di fornitura
              </p>
            </SiteLink>
            <SiteLink
              target={'_blank'}
              rel={'noopener noreferrer nofollow'}
              className="weight-500"
              to={`https://my.tate.it/documents/${web.documents_folder}/PLACET_BUSINESS_LUCE_VAR/condizioni_economiche.pdf`}
              name={'Condizioni economiche'}
            >
              <p css={[Typography.label.label1_500, Spacing.Flex.vertical_center, Spacing.Margin.vertical_24]}>
                <ArrowRightIcon color={eerieBlack['800']} css={[Spacing.Padding.right_8]}/>
                Condizioni economiche
              </p>
            </SiteLink>
          </div>
        </Card>
        <ListSpacer horizontalSize={36} verticalSize={40}/>
        <Card order={2}>
          <div className="col-12 col-sm-10 offset-sm-2">
            <h4 css={[Typography.heading.h6_700]}>Documentazione contrattuale <br/> tariffa a Prezzo Fisso</h4>
            <SiteLink
              target={'_blank'}
              rel={'noopener noreferrer nofollow'}
              className="weight-500"
              to={`https://my.tate.it/documents/${web.documents_folder}/PLACET_BUSINESS_LUCE_FIX/condizioni_generali_fornitura.pdf`}
              name={'Condizioni generali di fornitura'}
            >
              <p css={[Typography.label.label1_500, Spacing.Margin.vertical_24, Spacing.Flex.vertical_center]}>
                <ArrowRightIcon color={eerieBlack['800']} css={[Spacing.Padding.right_8]}/>
                Condizioni generali di fornitura
              </p>
            </SiteLink>
            <SiteLink
              target={'_blank'}
              rel={'noopener noreferrer nofollow'}
              className="weight-500"
              to={`https://my.tate.it/documents/${web.documents_folder}/PLACET_BUSINESS_LUCE_FIX/condizioni_economiche.pdf`}
              name={'Condizioni economiche'}
            >
              <p css={[Typography.label.label1_500, Spacing.Flex.vertical_center, Spacing.Margin.vertical_24]}>
                <ArrowRightIcon color={eerieBlack['800']} css={[Spacing.Padding.right_8]}/>
                Condizioni economiche
              </p>
            </SiteLink>
          </div>
        </Card>
      </CardsContainer>
    </Body>
  )
}

export default TariffePlacetPage
